import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { App } from "./App";
export function AppRouter() {
  return <BrowserRouter data-id="element-9">
        <Routes data-id="element-10">
          <Route path="/" element={<App data-id="element-12" />} data-id="element-11" />
        </Routes>
    </BrowserRouter>;
}